/**
 * Centralized handler for 401 authentication errors
 * Shows user notification and reloads page to trigger login redirect
 */
import { toast } from 'react-toastify';

// Flag to prevent multiple simultaneous 401 handling
let isHandling401 = false;

/**
 * Handle 401 authentication errors
 * - Shows warning toast notification
 * - Saves current URL for return after login
 * - Reloads page after 1 second
 * - Prevents duplicate handling with debounce flag
 */
export const handle401Error = () => {
  // Prevent duplicate handling
  if (isHandling401) {
    console.log('⏭️ 401 already being handled, skipping...');
    return;
  }

  isHandling401 = true;
  console.log('🚨 Handling 401 error...');

  // Clear token
  localStorage.removeItem('auth_token');

  // Save current URL for return after login (if not already on login/auth pages)
  const currentPath = window.location.pathname + window.location.search;
  if (!currentPath.startsWith('/login') && !currentPath.startsWith('/auth/')) {
    localStorage.setItem('returnUrl', currentPath);
    console.log('💾 Saved return URL:', currentPath);
  }

  // Show notification to user
  toast.warning('Session expired, reloading...', {
    position: 'top-center',
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false
  });

  // Reload page after showing notification
  setTimeout(() => {
    console.log('🔄 Reloading page due to expired session...');
    window.location.reload();
  }, 1000);
};

export default handle401Error;
